module.exports = __webpack_public_path__ + "img/4-4.07171b4b.svg";